module.exports = __webpack_public_path__ + "img/072.a8569f17.png";